import { render } from "./RequestApprovalHistory.vue?vue&type=template&id=4ae8ecf8"
import script from "./RequestApprovalHistory.vue?vue&type=script&lang=js"
export * from "./RequestApprovalHistory.vue?vue&type=script&lang=js"

import "./RequestApprovalHistory.vue?vue&type=style&index=0&id=4ae8ecf8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__